<div class="d-control-input d-control-input--appearance_bordered"><textarea class="d-control-input__element" v-bind="$attrs"></textarea></div>